import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import {  MatSort  } from '@angular/material/sort';
import { DateAdapter } from '@angular/material/core';
import { MatTableDataSource } from '@angular/material/table';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormGroupDirective, NgForm } from '@angular/forms';

import { SnackBarIconService } from '../../../shared/snack-bar-icon/snack-bar-icon.service';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Subscription } from 'rxjs';
import { ActivityService } from 'src/app/services/activity.service';
//import { Event, Activity, Day } from 'src/app/models/event';
import { EventActivityDialogComponent } from '../event-activity-dialog/event-activity-dialog.component';
import { TopicService } from 'src/app/services/topic.service';
import { ConfirmComponent } from 'src/app/shared/dialogs/confirm/confirm.component';
import { DayService } from 'src/app/services/day.service';
//import { TeamService } from 'src/app/services/__team.service';
import {AgendaService} from 'src/app/services/agenda.service';
import {Department} from 'src/app/models/department';
import {DepartmentService} from 'src/app/services/department.service';
import {Activity} from 'src/app/models/event';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-event-day-dialog',
  templateUrl: './event-day-dialog.component.html',
  styleUrls: ['./event-day-dialog.component.scss'],
  entryComponents: [
    ConfirmComponent,
    EventActivityDialogComponent
  ],
})
export class EventDayDialogComponent implements OnInit {

  public Editor = ClassicEditor;
  public matcher = new FormErrorStateMatcher();

  public teamRoleForm: FormGroup;
  public dayForm: FormGroup;
  public pdfForm: FormGroup;   
  
  public displayedColumns: string[] = ['icon', 'startTime', 'name', 'location', 'edit', 'delete'];
  // public displayedColumns: string[] = ['icon', 'startTime', 'edit', 'delete'];

  public activityDataSource: MatTableDataSource<any>
  public subscriptionActivities: Subscription;

  public topicDataSource: MatTableDataSource<any>
  public subscriptionTopic: Subscription;

  public displayedPdfColumns: string[] = ['icon', 'name', 'delete'];

  public selectedDepartent: Department;

  @ViewChild(MatSort, { static: false }) sort: MatSort;

  // @ViewChild('activeSort', {read: MatSort, static: true}) activeSort: MatSort;
  
  constructor(
    public _agendaService: AgendaService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    public _dayService: DayService,
    public _departmentService: DepartmentService,
    public _activityService: ActivityService,
    public _topicService: TopicService,
    private _adapter: DateAdapter<any>,
    public matDialogRef: MatDialogRef<EventDayDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this._dayService.currentEvent = this.data.event;
    this._dayService.currentDay = this.data.day;

    this._departmentService.loadDeptos(this._dayService.currentEvent.context_id);

  }

  ngOnInit() {
    this._adapter.setLocale('pt');

    this._dayService.setEdit()

    this.dayForm = this._dayService.createForm(this._dayService.currentEvent, this._dayService.currentDay)
    this.pdfForm = this._dayService.createPdfForm();

    if (this._dayService.isEdit){
      this._dayService.setPdfDataSource();
     // this._activityService.selectByDay(this._dayService.currentDay.id)
     this.selectActivitiesByDay(this._dayService.currentDay.id)
    } 

  }

  ngOnDestroy() {
  }

  applyFilter(filterValue: string) {
    this._activityService.activityDataSource.filter = filterValue.trim().toLowerCase();
  }

  selectActivitiesByDay(day_id: string){

    this._activityService.selectByDay(day_id)
    .subscribe((result) => {
      let array: Activity[] = []

      array = this._activityService.makeDay(result)
      array.sort(this._activityService.compareActivities)
      // console.log(JSON.stringify(array))
      this.activityDataSource = new MatTableDataSource(array);
      this.activityDataSource.sort = this.sort
    })
  }

  insert() {
    if (this.dayForm.valid) {
      this._activityService.select('', '')
      this._dayService.insert(this.dayForm.value)
      .then(()=>{     
          const array:any[]=[]
          this._activityService.activityDataSource = new MatTableDataSource(array);     
           this.matDialogRef.close()
      })
      .catch((err)=>{
        console.log("erro ao adicionar dia")
      })
    }
  }

  update() {
    if (this.dayForm.valid) {
      this._dayService.update(this._dayService.currentDay.id, this.dayForm.value)
    }
  }

  openActivityDialog(activity) {

    this._agendaService.agendaActivityNotes = []
    this._agendaService.agendaActivityDataSource = new MatTableDataSource(this._agendaService.agendaActivityNotes);


    let data = {
      event: this._dayService.currentEvent,
      day: this._dayService.currentDay,
      activity: activity
    }

    const w = window.innerWidth - 410;
    const h =  window.innerHeight - 90;

    let dialogRef = this.dialog.open(EventActivityDialogComponent, {
      id: "c",
      width:  w.toString() + "px",
      height: h.toString() + "px",
      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {

      //let tempData = this._activityService.activityDataSource.data    
      //this._activityService.activityDataSource.data = tempData

    })

  }

  deleteActivity(element) {
    this._activityService.delete(element)
  }

    uploadFilePdf() {
      if (this._dayService.objectPdf) {
        this._dayService.uploadFilePdf(this._dayService.objectPdf, this.pdfForm.value);
      }
  
    }
  
    selectFile(obj) {
  
      if (obj.target.files.length === 0)
        return;
  
      var mimeType = obj.target.files[0].type;
      if (mimeType.match('.pdf') == null) {
        this.snackBar.openSnackBar("Apenas arquivos PDF", '', 'info');
        return;
      }
  
      this._dayService.objectPdf = obj.target.files[0];
      this.pdfForm.controls.original.setValue(obj.target.files[0].name);
    }
  
    removeFilePdf(element) {
  
    }
    
    goToLink(url: string) {
      window.open(url, "_blank");
    }

}

